import React, {Component} from 'react';

class CoinDetailTableHeader extends Component {
    render() {
        return (
            <thead>
            <tr>
                <th className="left-padding left">Market cap</th>
                <th className="left">Volume</th>
            </tr>
            </thead>
        );
    }
}

export default CoinDetailTableHeader;



// WEBPACK FOOTER //
// ./src/CoinDetailTableHeader.js